(function () {
  'use strict';
  const configElement = document.getElementById('SecondPairConfig');
  const core = window.SleepSpecPairOffer;
  if (!configElement || !core) return;
  const config = JSON.parse(configElement.textContent);
  const designPreview = config.editor || (
    ['127.0.0.1', 'localhost', '[::1]'].includes(window.location.hostname) &&
    new URLSearchParams(window.location.search).get('offer-preview') === '1'
  );
  const cartUrl = config.cartUrl;
  const page = document.querySelector('[data-second-pair-page]');
  let busy = false;
  let bypass = false;
  let currentCart;
  // Access storage lazily: privacy settings must never block checkout.
  const declineMemory = core.createDeclineMemory({
    getItem: (key) => sessionStorage.getItem(key),
    setItem: (key, value) => sessionStorage.setItem(key, value),
    removeItem: (key) => sessionStorage.removeItem(key),
  }, config);

  async function request(path, body) {
    const response = await fetch(path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
      ...(body ? { body: JSON.stringify(body) } : { signal: AbortSignal.timeout(5000) }),
    });
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }
  const api = {
    get: async () => {
      const cart = await request(`${cartUrl}.js`);
      declineMemory.matches(cart); // Forget a decline when the saved basket changes.
      return cart;
    },
    change: (body) => request(`${cartUrl}/change.js`, body),
    update: (body) => request(`${cartUrl}/update.js`, body),
  };
  if (!designPreview && config.enabled) {
    // Clear on edits as well as reads, including a quantity changed away and back.
    document.addEventListener('change', (event) => {
      if (event.target.name === 'updates[]') declineMemory.clear();
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.cartData?.items) declineMemory.matches(event.cartData);
        else api.get().catch(() => {});
      });
    }
  }
  function checkout() {
    // The discount is already applied and verified on the cart. Use Shopify's
    // native cart checkout so development previews also preserve the session.
    page.querySelector('[data-offer-checkout-form]').requestSubmit();
  }
  function hasPendingQuantity(form, cart) {
    const quantities = Array.from(form?.querySelectorAll('[name="updates[]"]') || []);
    return Boolean(form?.closest('cart-items, cart-drawer-items')?.querySelector('.cart__items--disabled')) ||
      (quantities.length && (quantities.length !== cart.items.length ||
      quantities.some((input, index) => Number(input.value) !== cart.items[index].quantity)));
  }
  async function settledCart(form) {
    // Dawn debounces quantity edits before saving them. Check the saved basket
    // after that update, rather than skipping the offer using an old quantity.
    for (let attempt = 0; attempt < 20; attempt += 1) {
      const cart = await api.get();
      if (!hasPendingQuantity(form, cart)) return cart;
      await new Promise((resolve) => setTimeout(resolve, 250));
    }
    throw new Error('Cart quantity is still updating');
  }
  async function gate(resume, form) {
    if (busy) return;
    busy = true;
    try {
      const cart = await settledCart(form);
      if (!core.eligible(cart, config) || declineMemory.matches(cart)) {
        resume();
        return;
      }
      const note = form?.querySelector('[name="note"]');
      if (note && note.value !== (cart.note || '')) await api.update({ note: note.value });
      window.location.assign(config.offerUrl);
    } catch (_) {
      resume();
    } finally {
      busy = false;
    }
  }
  if (!config.isOfferPage && config.enabled && config.discountCode && !config.editor) {
    document.addEventListener('submit', (event) => {
      if (bypass || event.defaultPrevented || event.submitter?.name !== 'checkout') return;
      const form = event.target;
      if (new URL(form.action, location.href).pathname !== cartUrl) return;
      event.preventDefault();
      gate(() => {
        bypass = true;
        try {
          // Dawn may replace the checkout button while rendering cart totals.
          const submitter = Array.from(form.elements).find((element) => element.name === 'checkout');
          if (submitter) form.requestSubmit(submitter);
          else {
            const checkoutInput = document.createElement('input');
            checkoutInput.type = 'hidden';
            checkoutInput.name = 'checkout';
            checkoutInput.value = 'Checkout';
            form.appendChild(checkoutInput);
            form.requestSubmit();
            checkoutInput.remove();
          }
        } finally { bypass = false; }
      }, form);
    }, true);
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
      event.preventDefault();
      gate(() => window.location.assign(link.href));
    }, true);
  }
  if (!page) return;
  const offer = page.querySelector('[data-offer-content]');
  const fallback = page.querySelector('[data-offer-fallback]');
  const accept = page.querySelector('[data-offer-accept]');
  const decline = page.querySelector('[data-offer-decline]');
  const status = page.querySelector('[data-offer-status]');
  const review = page.querySelector('[data-offer-review]');
  const declineForm = page.querySelector('[data-decline-form]');
  function unavailable() {
    offer.hidden = true;
    fallback.hidden = false;
  }
  async function refresh() {
    if (busy || designPreview) return;
    accept.disabled = true;
    try {
      currentCart = await api.get();
      if (!core.eligible(currentCart, config) || declineMemory.matches(currentCart)) {
        unavailable();
        return;
      }
      offer.hidden = false;
      fallback.hidden = true;
      accept.disabled = false;
    } catch (_) { unavailable(); }
  }
  declineForm.addEventListener('submit', (event) => {
    if (designPreview || busy) {
      event.preventDefault();
      return;
    }
    if (!event.defaultPrevented && currentCart) declineMemory.remember(currentCart);
  });
  accept.addEventListener('click', async () => {
    if (busy || designPreview) return;
    busy = true;
    accept.disabled = true;
    decline.disabled = true;
    offer.setAttribute('aria-busy', 'true');
    status.textContent = config.messages.working;
    try {
      const result = await core.acceptOffer(api, config);
      if (result.status === 'accepted') {
        declineMemory.clear();
        checkout();
        return;
      }
      if (result.status === 'changed') {
        unavailable();
        return;
      }
      if (result.status === 'restored') {
        currentCart = result.cart;
        status.textContent = config.messages.restored;
        decline.disabled = false;
      } else {
        status.textContent = config.messages.review;
        declineForm.hidden = true;
      }
      review.hidden = false;
    } catch (_) {
      status.textContent = config.messages.unavailable;
      review.hidden = false;
      declineForm.hidden = true;
    } finally {
      busy = false;
      offer.removeAttribute('aria-busy');
    }
  });
  if (designPreview) {
    offer.hidden = false;
    fallback.hidden = true;
    accept.disabled = true;
    decline.disabled = true;
    status.textContent = 'Design preview — checkout actions are disabled.';
  } else {
    refresh();
    window.addEventListener('pageshow', (event) => { if (event.persisted) refresh(); });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') refresh();
    });
  }
})();
